import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { SearchResponse } from "src/api/search";
import { search } from "src/api/search";

import options from "./defaultOptions";

type GlobalSearchParams = {
	searchValue: string;
	take: number;
};

export function useGlobalSearch(params: GlobalSearchParams) {
	return useQuery<SearchResponse, Error>({
		queryKey: ["global-search", params],
		queryFn: () => search(params),
		...options,
		placeholderData: keepPreviousData,
	});
}
